import { AxiosStatic } from 'axios';

import {
	GenericPostPlaceholders,
	buildGenericPostRequest,
} from 'src/components/phoneCall/phoneCallGateway/genericPostRequest/genericPostRequest';
import { phoneCallProviderRequestConfig } from 'src/components/phoneCall/phoneCallGateway/phoneCallProviderRequestConfig';
import { providerRequestTarget } from 'src/components/phoneCall/phoneCallGateway/providerRequestTarget';

export const sendGenericPostRequest = async (
	axios: AxiosStatic,
	template: string,
	placeholders: GenericPostPlaceholders
): Promise<void> => {
	const request = buildGenericPostRequest(template, placeholders);
	const target = providerRequestTarget(request.url);

	await axios.post(
		target.url,
		request.body,
		phoneCallProviderRequestConfig({
			headers: target.headers,
			withCredentials: false,
		})
	);
};
